// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1vaCh","head":"Table_head__1C4Wl","col":"Table_col__1mGmS"};